<div class="grid mb-3">
  @if (affectedUser?.isAdmin) {
  <div class="col-12">
    <small class="p-text-secondary">
      {{ "ADMIN.USERS.ACCESS.ADMIN_HINT" | translate }}
    </small>
  </div>
  }

  <div class="col-12 md:col-5">
    <label class="block mb-2">{{ "COMMON.SEARCH" | translate }}</label>
    <input
      pInputText
      type="text"
      [placeholder]="'COMMON.SITE' | translate"
      [(ngModel)]="siteFilter"
      fluid
    />
  </div>

  <div class="col-12 md:col-4">
    <label class="block mb-2">{{ "COMMON.ROLE" | translate }}</label>
    <p-select
      size="small"
      [options]="roles"
      optionLabel="name"
      optionValue="id"
      appendTo="body"
      [(ngModel)]="bulkRoleId"
      fluid
    ></p-select>
  </div>

  <div class="col-12 md:col-3 flex align-items-end">
    <button
      pButton
      type="button"
      class="virtualcenter-button virtualcenter-button--primary w-full"
      [disabled]="filteredSites.length === 0"
      (click)="applyBulkRoleOnFilteredSites()"
    >
      {{ "COMMON.APPLY" | translate }} ({{ filteredSites.length }})
    </button>
  </div>
</div>

<p-table [value]="filteredSites" [tableStyle]="{ 'min-width': '50rem' }">
  <ng-template pTemplate="header">
    <tr>
      <th>{{ "COMMON.SITE" | translate }}</th>
      <th>{{ "COMMON.ROLE" | translate }}</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-site>
    <tr>
      <td>{{ site.name }}</td>
      <td>
        <div class="p-fluid">
          <p-select
            size="small"
            [options]="this.roles"
            optionLabel="name"
            optionValue="id"
            appendTo="body"
            [(ngModel)]="this.sitesRoles[site.id || -1]"
            (onChange)="this.updateRole(site)"
            fluid
          ></p-select>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
